import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div>
      <section className="py-16 md:py-24" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-bold mb-8"
            style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
            data-testid="privacy-heading"
          >
            Privacy Policy
          </h1>
          <p className="text-sm mb-8" style={{ color: '#94A3B8' }}>
            Last updated: April 2026
          </p>

          <article className="space-y-8" data-testid="privacy-content">
            <div
              className="p-6 border-l-4"
              style={{ borderColor: '#FF5722', backgroundColor: '#FFF4E6' }}
            >
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm (dhanamm.com) is partnered with Angel One for Demat account openings, Mutual Funds, Insurance, and other financial products. We are not a SEBI registered company and we do not provide any advisory from our side. We only work as a middlemen who transit Angel One advisories, resolve your technical app related issues such as buying, selling, profile updates, etc. Our Sub Broker code is <strong style={{ color: '#0A0F1A' }}>MNUL</strong> and we use Angel One's SEBI license and work along with Angel One.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                1. Information We Collect
              </h2>
              <p className="text-base leading-relaxed mb-3" style={{ color: '#475569' }}>
                When you use our website or services, we may collect the following information:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="text-base" style={{ color: '#475569' }}>
                  <strong style={{ color: '#0A0F1A' }}>Personal Information:</strong> Name, email address, phone number, and other details you provide through our contact form or account opening process.
                </li>
                <li className="text-base" style={{ color: '#475569' }}>
                  <strong style={{ color: '#0A0F1A' }}>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and referral sources.
                </li>
                <li className="text-base" style={{ color: '#475569' }}>
                  <strong style={{ color: '#0A0F1A' }}>Device Information:</strong> Browser type, IP address, operating system, and device identifiers.
                </li>
              </ul>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                2. How We Use Your Information
              </h2>
              <p className="text-base leading-relaxed mb-3" style={{ color: '#475569' }}>
                We use the collected information for the following purposes:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="text-base" style={{ color: '#475569' }}>To facilitate Demat account opening through our partner Angel One.</li>
                <li className="text-base" style={{ color: '#475569' }}>To respond to your enquiries and provide customer support.</li>
                <li className="text-base" style={{ color: '#475569' }}>To send relevant updates about your account or our services (with your consent).</li>
                <li className="text-base" style={{ color: '#475569' }}>To improve our website and user experience.</li>
                <li className="text-base" style={{ color: '#475569' }}>To comply with applicable legal obligations.</li>
              </ul>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                3. Information Sharing
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                We do not sell or rent your personal information to third parties. Your information may be shared with Angel One solely for the purpose of Demat account opening and related financial services. We may also share information when required by law or to protect our legal rights.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                4. Data Security
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                We implement reasonable security measures to protect your personal information from unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                5. Cookies
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Our website may use cookies and similar tracking technologies to enhance your browsing experience and analyse website traffic. You can control cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                6. Your Rights
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                You have the right to access, update, or request deletion of your personal information. To exercise these rights, please contact us at angeloneblr@gmail.com or call us at +91 99023 00787.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                7. Changes to This Policy
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                8. Contact Us
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <p className="text-base mt-2" style={{ color: '#475569' }}>
                <strong style={{ color: '#0A0F1A' }}>Email:</strong> angeloneblr@gmail.com<br />
                <strong style={{ color: '#0A0F1A' }}>Phone:</strong> +91 99023 00787<br />
                <strong style={{ color: '#0A0F1A' }}>Angel One SEBI Registration No:</strong> 1N2000161534<br />
                <strong style={{ color: '#0A0F1A' }}>Address:</strong> AECS Layout, A Block, Singasandra, Bangalore 560068
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
